import pyFormInput from 'pylon-vue/src/components/form-input/form-input';

const sFormInput = {
    name: 'sFormInput',
    extends: pyFormInput,
    props: {
        autocomplete: {
            default: "off"
        }
    }
}

export default sFormInput